import * as React from 'react';

import XBadge16 from './XBadge16';

export const xBadge16 = () => <XBadge16 />;

export default {
    title: 'Icon|Line|XBadge16',
    component: XBadge16,
    parameters: {
        notes: "`import XBadge16 from 'box-ui-elements/es/icon/line/XBadge16';`",
    },
};
